import { Component, OnInit } from '@angular/core';
import { CashClosureRequest } from 'src/app/models/cash-closure.model';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { InvoiceSaleService } from '../invoice-sale/invoice-sale.service';
import { BudgetService } from 'src/app/services/bugdet.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { HttpErrorResponse } from '@angular/common/http';
import { VendorService } from 'src/app/services/vendor.service';
declare let $: any;

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.scss']
})
export class BudgetComponent implements OnInit {
  availableYears: number[] = [2023, 2024, 2025, 2026, 2027, 2028];
  myYear: number;
  availableWarehouse: any[];
  availableMonth: string[] = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  myMonth: string = '';
  myWarehouse: number;
  loading = false;
  nomenclature = [];
  displayNomenclature = [];
  saving = false;
  searching = false;
  clients = [];
  filterClients = [];
  accountReceivable = [];
  cashClosureRequest: CashClosureRequest = new CashClosureRequest();
  closed = false;
  input = {
    client: {
      value: '',
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: '',
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  warehouseName: { [key: number]: string } = {};

  inputClients = {};
  providers = [];
  editing = null;
  timeout = null;
  constructor(
    private cashService: InvoiceSaleService,
    private toastService: ToastrService,
    private budgetService: BudgetService,
    private providerService: VendorService
  ) {
  }

  ngOnInit(): void {
    var previousList = sessionStorage.getItem('account-receivable-temp');
    if (previousList)
      this.accountReceivable = JSON.parse(previousList);
    this.getWarehouses();
    this.getNomenclature(2023, 1);
    this.cashService.getClientsByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.filterClients = response.data;
        this.clients = response.data;
      }, error: (error: any) => {
      }
    })
    this.providerService.getProvidesByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.providers = response.data;
      }, error: (error: any) => {
      }
    })
  }

  onMonthSelect(value, type) {
    if (value == 'undefined' || !value) {
      this.displayNomenclature = [];
      this.editing = null;
      switch (type) {
        case 0: this.myYear = undefined; break;
        case 1: this.myMonth = undefined; break;
        case 2: this.myWarehouse = undefined; break;
      }
      this.budgetService.getNomenclatureByAccounts().subscribe({
        next: (response: ResponseObject) => {
          this.nomenclature = response.data;
          this.orderNomenclature(this.nomenclature);
        }
      });
      return;
    } else {
      this.getDateBudget();
    }
  }

  getDateBudget() {
    if (this.myYear && this.myMonth && this.myWarehouse) {
      this.searching = true;
      const monthNumber = this.getMonthNumber(this.myMonth);
      if (monthNumber !== -1) {
        this.displayNomenclature = [];
        this.budgetService.getNomenclature(this.myYear, this.getMonthNumber(this.myMonth)).subscribe({
          next: (response: ResponseObject) => {
            if (response.data && response.data.length > 0) {
              this.nomenclature = response.data;
              this.orderNomenclature(this.nomenclature);
              this.getValues();
            } else {
              this.budgetService.getNomenclatureByAccounts().subscribe({
                next: (response: ResponseObject) => {
                  this.nomenclature = response.data;
                  this.orderNomenclature(this.nomenclature);
                  this.getValues();
                }
              })
            }
          },
          error: (error: any) => {
            this.searching = false;
            this.toastService.error("Error al obtener la nomenclatura, por favor recarga la página");
          }
        });
      }
    }
  }

  insertNewBudget(budget: any) {
    var parent = budget.displayId.slice(0, 4);
    var index = -1;
    for (let i = 0; i < this.displayNomenclature.length; i++) {
      const item = this.displayNomenclature[i];
      if (item.displayId == parent) {
        index = i;
        item.last = false;
        break;
      }
    }

    var children = this.displayNomenclature.filter(n => n.parent == this.displayNomenclature[index].id).length + 1;
    if ((budget.displayId.substring(0, 2) == '41') || ((budget.displayId.substring(0, 1) == '5') && budget.displayId.substring(0, 3) != '521')) {
      this.inputClients[parent + "" + children] = {
        value: budget.name,
        verified: false,
        required: false,
        message: 'Campo requerido',
        class: 'fa fa-circle-check',
        color: '',
        tooltip: '',
        data: null,
        filterElements: ((budget.displayId.substring(0, 1) != '5')) ? this.clients : this.providers
      }
    }
    var toInsert = {
      name: budget.name,
      displayId: parent + "" + children,
      balance: -1,
      level: 5,
      showed: false,
      last: true,
      id: budget.id,
      parent: this.displayNomenclature[index].id,
      budget: budget.budget
    };
    this.putCommas(toInsert);
    this.displayNomenclature.splice(index + children, 0, toInsert);
  }

  getValues() {
    this.budgetService.getBudget(this.myYear, this.getMonthNumber(this.myMonth), this.myWarehouse).subscribe(
      {
        next: (response: ResponseObject) => {
          console.log(response.data);
          if (response.data.length > 0) {
            this.editing = { year: this.myYear, month: this.getMonthNumber(this.myMonth), warehouse: this.myWarehouse };
            var newBudgets: { [key: number]: any } = {}
            this.displayNomenclature.forEach((budget, i) => {
              newBudgets[budget.displayId] = { item: budget, index: i };
            });
            for (let i = 0; i < response.data.length; i++) {
              const budget = response.data[i];
              if (newBudgets[budget.displayId]) {
                newBudgets[budget.displayId].item.budget = response.data[i].budget;
                this.putCommas(newBudgets[budget.displayId].item);
              } else {
                this.insertNewBudget(budget);
              }
            }
          } else {
            this.toastService.info("No existe el presupuesto, tendrás que crearlo");
            this.editing = null;
          }
          this.searching = false;
        }
        ,
        error: (error: HttpErrorResponse) => {
          this.searching = false;
          this.toastService.error(error.error.message);
        }
      }
    );
  }

  getMonthNumber(monthName: String): number {
    const index = this.availableMonth.findIndex(month => month === monthName);
    if (index !== -1) {
      return index + 1;
    } else {
      return -1;
    }
  }

  getWarehouses() {
    this.cashService.getWarehouses().subscribe(
      (response) => {
        this.availableWarehouse = Object(response)['data'];
        this.availableWarehouse.forEach((w) => {
          this.warehouseName[w.id] = w.name;
        });
        //console.log(response)
      },
      (error) => {
        //console.log("Failed to get warehouse list. More about the error: " + error);
      }
    )
  }

  addRow(x, index) {
    var displayId = x.id;
    x.last = false;
    x.showing = true;
    var children = this.displayNomenclature.filter(n => n.parent == displayId).length + 1;
    if (index !== -1) {
      var newRow = {
        name: '',
        displayId: x.displayId + children,
        balance: null,
        showing: false,
        showed: true,
        level: 5,
        last: true,
        parent: displayId
      };
      if ((x.displayId.substring(0, 2) == '41') || ((x.displayId.substring(0, 1) == '5') && x.displayId.substring(0, 3) != '521')) {
        this.inputClients[x.displayId + children] = {
          value: '',
          verified: false,
          required: false,
          message: 'Campo requerido',
          class: '',
          color: '',
          tooltip: '',
          data: null,
          filterElements: ((x.displayId.substring(0, 1) != '5')) ? this.clients : this.providers
        }
      }
      this.displayNomenclature.splice(index + children, 0, newRow);
      setTimeout(() => {
        $('#n' + x.displayId + children).focus();
      })
    }
    this.showRows(x);
    //this.actualizarPresupuestos();
  };

  removeRow(budget, index) {
    this.displayNomenclature.splice(index, 1);
    var children = this.displayNomenclature.filter(n => n.parent == budget.parent);
    if (children.length == 0) {
      var parent = this.displayNomenclature.find((n) => budget.parent == n.id);
      parent.last = true;
      parent.showing = false;
    }
    for (let index = 0; index < children.length; index++) {
      const element = children[index];
      element.displayId = element.displayId.substring(0, 4) + "" + (index + 1);
    }
    this.updateBudget(budget);
  }

  getNomenclature(year: number, month: number) {
    this.budgetService.getNomenclature(year, month).subscribe({
      next: (response: ResponseObject) => {
        if (response.data && response.data.length > 0) {
          this.nomenclature = response.data;
          this.orderNomenclature(this.nomenclature);
        } else {
          this.budgetService.getNomenclatureByAccounts().subscribe({
            next: (response: ResponseObject) => {
              this.nomenclature = response.data;
              this.orderNomenclature(this.nomenclature);
            }
          })
        }
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener la nomenclatura, por favor recarga la página");
      }
    });
  }

  show(x) {
    x.showing = !x.showing;
    this.showRows(x);
  }

  showRows(x) {
    var parent:string = x.displayId;
    this.displayNomenclature.forEach((p) => {
      if (x.id == p.parent) {
        p.showed = x.showing;
      }
      var child:string = p.displayId;
      if (!x.showing){
        if (child.length > parent.length){
          var parentDisplayId:string = child.substring(0, parent.length);
          if (parentDisplayId == parent){
            p.showed = false;
            p.showing = false;
          }
        }
      }

    })
  }
  /* orderNomenclature(data: any) {
    if (data && Array.isArray(data)) {
      data.forEach(value => {
        //console.log(value, this.displayNomenclature);
        this.displayNomenclature.push({
          name: value.name,
          displayId: value.displayId,
          balance: value.balance,
          level: value.level,
          showed: true,
          id: value.id,
          parent: 0
        });

        if (value.children && Array.isArray(value.children)) {
          value.children.forEach(value2 => {
            this.displayNomenclature.push({
              name: value2.name,
              displayId: value2.displayId,
              balance: value2.balance,
              level: value2.level,
              id: value2.id,
              showed: false,
              parent: value.displayId
            });

            if (value2.children && Array.isArray(value2.children)) {
              value2.children.forEach(value3 => {
                this.displayNomenclature.push({
                  name: value3.name,
                  displayId: value3.displayId,
                  balance: value3.balance,
                  level: value3.level,
                  id: value3.id,
                  showed: false,
                  parent: value2.displayId
                });

                if (value3.children && Array.isArray(value3.children)) {
                  value3.children.forEach(value4 => {
                    this.displayNomenclature.push({
                      name: value4.name,
                      displayId: value4.displayId,
                      balance: value4.balance,
                      level: value4.level,
                      id: value4.id,
                      last: true,
                      showed: false,
                      parent: value3.displayId
                    });
                  });
                }
              });
            }
          });
        }
      });
    }
  } */
  orderNomenclature(data: any[], parent = 0) {
    if (!data || !Array.isArray(data)) return;
    data.forEach(value => {
      this.displayNomenclature.push({
        name: value.name,
        displayId: value.displayId,
        balance: value.balance,
        level: value.level,
        showed: parent == 0,
        id: value.id,
        parent: parent,
        last: value.children.length == 0
      });
      if (value.children && Array.isArray(value.children)) {
        this.orderNomenclature(value.children, value.id);
      }
    });
  }

  updatePresupuesto(item) {
    if (item.level === 4) {
      var totalPresupuesto = 0;
      this.displayNomenclature.forEach(x => {
        if (x.level === 5 && x.displayId.startsWith(item.displayId)) {
          totalPresupuesto += parseFloat(x.budget || 0);
        }
      });
      item.budget = totalPresupuesto.toFixed(2);
    } else if (item.level === 3) {
      var totalPresupuesto = 0;
      this.displayNomenclature.forEach(x => {
        if (x.level === 4 && x.displayId.startsWith(item.displayId)) {
          totalPresupuesto += parseFloat(x.budget || 0);
        }
      });
      item.budget = totalPresupuesto.toFixed(2);
    } else if (item.level === 2) {
      var totalPresupuesto = 0;
      this.displayNomenclature.forEach(x => {
        if (x.level === 3 && x.displayId.startsWith(item.displayId)) {
          totalPresupuesto += parseFloat(x.budget || 0);
        }
      });
      item.budget = totalPresupuesto.toFixed(2);
    } else if (item.level === 1) {
      var totalPresupuesto = 0;
      this.displayNomenclature.forEach(x => {
        if (x.level === 2 && x.displayId.startsWith(item.displayId)) {
          totalPresupuesto += parseFloat(x.budget || 0);
        }
      });
      item.budget = totalPresupuesto.toFixed(2);
    }
  };

  actualizarPresupuestos() {
    this.displayNomenclature.forEach(element => {
      this.updatePresupuesto(element);
    });
  };

  removeCommas(rowBudget) {
    rowBudget.budgetString = (rowBudget.budget) ? rowBudget.budget : '';
  }

  putCommas(rowBudget) {
    rowBudget.budgetString = (rowBudget.budget) ? 'Q ' + this.localStringToNumber(parseFloat(rowBudget.budget).toFixed(2)) :
      '';
  }

  localStringToNumber(s) {
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ",");;

  }

  updateBudget(x) {
    if (x.parent != 0) {
      var parent = x.parent;
      var tempNomenclature = this.displayNomenclature.filter((f) => {
        return f.parent == parent;
      });
      var total = 0;
      if (tempNomenclature) {
        tempNomenclature.forEach((n) => {
          total += (n.budget) ? parseFloat(n.budget) : 0;
        });
      }
      var parentObject = this.displayNomenclature.find((f) => {
        return f.id == parent;
      })
      if (parentObject) {
        parentObject.budget = total;
        this.putCommas(parentObject);
        this.updateBudget(parentObject);
      }
    }
  }

  convertToDecimal(budgetRow) {
    budgetRow.budget = budgetRow.budget.toFixed(2);
  }

  recursive(displayId) {

  }

  saveBudget() {
    this.saving = true;
    var accountList = this.displayNomenclature.map((item) => {
      return {
        level: item.level,
        parent: item.parent,
        displayId: item.displayId,
        name: item.name,
        budget: item.budget,
        warehouse: this.myWarehouse
      };
    });
    accountList = accountList.filter((item) => {
      return item.budget ? true : false;
    })
    if (this.editing) {
      this.budgetService.updateBudget(this.myYear, this.getMonthNumber(this.myMonth), accountList).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se ha editado correctamente el presupuesto");
          this.editing = null;
          this.saving = false;
          this.getDateBudget();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.saving = false;
        }
      })
    } else {
      this.budgetService.saveBudget(this.myYear, this.getMonthNumber(this.myMonth), accountList).subscribe({
        next: (response: ResponseObject) => {
          this.toastService.success("Se ha guardado correctamente el presupuesto");
          this.editing = null;
          this.saving = false;
          this.getDateBudget();
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
          this.saving = false;
        }
      })
    }
  }

  getTodayDate(): string {
    const months = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    const date = new Date();
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} de ${month} de ${year}`;
  }

  verifiedInput(event: any) {

  }


  handleInput(event: any, input, budget) {
    clearTimeout(this.timeout);
    input.class = "typing";
    input.filterElements = this.clients.filter((c) => c.name.toLowerCase().includes(input.value.toLowerCase()));
    this.timeout = setTimeout(() => {
      if (input.filterElements.length == 1) {
        input.value = input.filterElements[0].name;
        budget.name = input.value;
        input.class = "fa fa-circle-check";
        input.required = false;
        $('body').click();
        $('#c' + budget.displayId + "-input").blur();
        $('#b' + budget.displayId).focus();
        //this.addClientToAccountList(this.filterClients[0]);
      } else if (input.filterElements.length == 0) {
        input.class = "fa-xmark";
        budget.name = input.value;
        input.required = true;
        this.toastService.error("No se encuentra el cliente " + input.value);
      }
    }, 1500);
  }

  changedClient(e, x) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      var inputValue = e.target.value;
      var filter = this.filterClients.filter((c) => {
        return c.name.toLowerCase().includes(inputValue)
      });
      if (filter.length == 1) {
        x.name = filter[0].name;
        this.addClientToAccountList(filter[0]);
      } else if (this.filterClients.length == 0) {
        this.toastService.error("No se encuentra el cliente " + inputValue);
      }
    }, 500);
  }

  selectClient(client: any, input, budget) {
    clearTimeout(this.timeout);
    input.value = client.name;
    input.class = "fa fa-circle-check";
    input.required = false;
    budget.name = input.value;
  }

  deleteClientOfList(index: number) {
    this.accountReceivable.splice(index, 1);
    sessionStorage.setItem('account-receivable-temp', JSON.stringify(this.accountReceivable));
  }

  addClientToAccountList(client: any) {
    var findOut = this.accountReceivable.find((c) => {
      return c.client.nit == client.nit
    });
    if (findOut) {
      this.toastService.info("El cliente ya se encuentra agregado a la lista");
    } else {
      this.accountReceivable.push({ client: client, amount: 0, type_payment: 0 });
      sessionStorage.setItem('account-receivable-temp', JSON.stringify(this.accountReceivable));
    }
  }
}
